module.exports = __webpack_public_path__ + "img/02.8b6a0c73.png";